import Link from "next/link";
import { useTranslations } from "next-intl";

import Icon from "~/components/common/icon";
import myaccount from "~/components/common/myaccount.module.scss";
import appRoutes from "~/utils/app-routes";
import Constants from "~/utils/constants";

import styles from "./birthday-card.module.scss";

type Props = {
  promo: EVA.Core.PrefigureDiscountResult;
};

export default function BirthdayCard(props: Props) {
  const t = useTranslations();

  return (
    <>
      <div className={myaccount.myaccountCard}>
        <div className={styles.container}>
          <Icon name="birthday" />
          <div className={styles.wrapperText}>
            <p className={styles.title}>{t("generic.your_birthday")}</p>
            <p className={styles.description}>
              {t.rich("generic.celebrate_your_birthday", {
                strong: (chunks) => <strong className={styles.bold}>{chunks}</strong>,
                br: () => <br />,
              })}
            </p>
          </div>

          {/* on click go to cart and apply couupon (if available) */}
          {/* IsAlreadyApplied false even if the coupon is correctly applied to the order */}
          <Link
            href={`${appRoutes.CART}/?${Constants.COUPON_KEY}=${props.promo.AvailableUserCoupons?.[0].Code}`}
            className={styles.link}
          >
            {t("generic.get_my_birthday_gift_now")}
          </Link>
        </div>
      </div>
    </>
  );
}
